import React from "react";
// import Svg from "../svgs/Svg";

const footCss = {
  height: "30px",
  lineHeight: "30px",
  textAlign: "center",
  fontSize: "16px",
  color: "#D5D5D5",
  marginTop: "20px",
  marginBottom: "40px",
};
const loadingCss = {
  display: "inline-block",
  height: "30px",
  width: "30px",
  verticalAlign: "bottom",
  marginRight: "10px",
};
class ScrollLoad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.disabled = true;
    this.data = [];
  }
  componentDidMount() {
    const { loadRef } = this.props;

    setTimeout(() => {
      loadRef.current
        ? loadRef.current.addEventListener("scroll", this.handleScroll)
        : window.addEventListener("scroll", this.handleScroll);
    }, 300);
  }
  componentWillUnmount() {
    const { loadRef } = this.props;
    loadRef.current
      ? loadRef.current.removeEventListener("scroll", this.handleScroll)
      : window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll(event) {
    const { onEndReachedThreshold, loadRef } = this.props;
    let scrollTop, scrollHeight, CountScroll = '';
    if (loadRef.current) {
      scrollTop =
        (event.srcElement ? event.srcElement.scrollTop : false) ||
        window.pageYOffset ||
        (event.srcElement ? event.srcElement.body.scrollTop : 0);

      scrollHeight = event.srcElement && event.srcElement.scrollHeight
    } else {
      scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop ||
        0;
      scrollHeight = document.body.scrollHeight;
    }
		CountScroll = scrollHeight - scrollTop < onEndReachedThreshold
    this.isOnLoadContent(CountScroll);
  }
  async isOnLoadContent(CountScroll) {
    if (CountScroll && this.disabled) {
      this.disabled = false;

      this.setState({
        isLoading: true,
      });

      await this.props.onEndReached();

      this.disabled = true;
    }
  }
  render() {
    const { children, paging } = this.props;
    const { isLoading } = this.state;

    return (
      <div>
        {children}
        {paging != "" ? (
          <div style={{ ...footCss }}>
            <div style={{ ...loadingCss }}>
              {/* <Svg name="loading" /> */}
            </div>
            <span>正在加載中...</span>
          </div>
        ) : (
          <div style={{ ...footCss }}>
            <span>已經到底啦</span>
          </div>
        )}
      </div>
    );
  }
}

export default ScrollLoad;
